<template>
  <div class="package-information">
    <h5 v-if="!isPayment">智工嗨搜基础版&资源包(组合)-新购</h5>
    <div class="ul" v-else>
      <h5>智工嗨搜基础版&资源包(组合)-新购</h5>
      <div class="li">
        <div class="label">订单号:</div>
        <div class="value">{{ productData.orderNo | noText }}</div>
      </div>
      <div class="li">
        <div class="label">下单时间:</div>
        <div class="value">{{ productData.orderTime | format }}</div>
      </div>
    </div>
    <el-table
      :span-method="objectSpanMethod"
      border
      :data="productData.specList"
    >
      <el-table-column label="产品">
        <template slot-scope="scope">
          <div>
            {{ scope.row.categoryShow | noText }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="200" label="规格">
        <template slot-scope="scope">
          <div v-if="!isPayment">
            <div v-if="scope.row.specCode !== 'HISE-SUBSCRIBE-BASE'">
              <div>类型：{{ scope.row.subscribeName | noText }}</div>
              <div>
                规格：{{ formatNumber(scope.row.specQuantity)
                }}{{ scope.row.unitShow }}
              </div>
            </div>
            <div v-else>基础版</div>
          </div>
          <div v-else>
            <div v-if="scope.row.subscribeCode !== 'HISE-SUBSCRIBE-BASE'">
              <div>类型：{{ scope.row.subscribeName | noText }}</div>
              <div>
                规格：{{ formatNumber(scope.row.specQuantity)
                }}{{ scope.row.unitShow }}
              </div>
            </div>
            <div v-else>基础版</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="服务有效期/月">
        <template slot-scope="scope">
          <div>
            {{ scope.row.duration | noText }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="售价">
        <template slot-scope="scope">
          <div v-if="isPayment">{{ scope.row.unitPrice | formatMoney }}元</div>
          <div v-else>{{ scope.row.price | formatMoney }}元</div>
        </template>
      </el-table-column>
      <el-table-column label="数量">
        <template>
          <div>1</div>
        </template>
      </el-table-column>
      <el-table-column label="优惠">
        <template slot-scope="scope">
          <div>{{ scope.row.discount | formatMoney }}元</div>
        </template>
      </el-table-column>
      <el-table-column width="300" label="说明" prop="description">
        <template slot-scope="scope" v-if="scope.$index === 0">
          <!-- <div v-if="userInfo.leadsStatus != 8">海智铂金会员，钻石会员，VIP会员，VVIP会员限时特惠</div>
          <div v-else>海智老朋友限时体验价</div> -->
          <div>--</div>
        </template>
      </el-table-column>
    </el-table>

    <div class="money">
      <div style="display: flex;align-items: center;" v-if="!isPayment">
        <div style="width: 80px;color: #16181aff; font-size: 14px; font-weight: 400; height: 14px; line-height: 14px; margin-left: 8px;">优惠码</div>
        <el-input :placeholder="'请输入优惠码'" v-model.trim="promoCode"  @blur="promoCodeBlur"></el-input>
      </div>
      <div class="labels">
        <div class="label">总价:</div>
        <div class="label">优惠:</div>
        <div class="label">应付:</div>
      </div>
      <div class="values" v-if="isPayment">
        <div class="value">¥{{ productData.totalAmount | formatMoney }}</div>
        <div class="value">
          - ¥{{ productData.totalDiscount | formatMoney }}
        </div>
        <div class="value">
          ¥{{ productData.realPaymentAmount | formatMoney }}
        </div>
      </div>
      <div class="values" v-else>
        <div class="value">¥{{ productData.totalPrice | formatMoney }}</div>
        <div class="value">- ¥{{ productData.discount | formatMoney }}</div>
        <div class="value">¥{{ productData.kitPrice | formatMoney }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { couponInfo } from '@/utils/api/order'
export default {
  props: {
    productData: {
      default() {
        return { specList: [{}, {}, {}] }
      },
    },
    isPayment: {
      default: false,
    },
  },
  data() {
    return {
      promoCode:''
    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 6) {
        return {
          rowspan: this.productData.specList.length,
          colspan: 1,
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1,
        }
      }
    },
    formatNumber(num) {
      if (!num) return 0
      if (num < 1000) {
        return num.toString()
      } else if (num < 10000) {
        return (num / 1000).toFixed(0) + '千'
      } else {
        return (num / 10000).toFixed(0) + '万'
      }
    },
    async promoCodeBlur(){
      if(this.promoCode!=null&&this.promoCode!=''){
        try {
          const params={
            promoCode:this.promoCode,
            kitName:this.productData.kitName,
          }
          const res = await couponInfo(params)
          if (res.rspResult.bizCode === 200) {
            //  优惠券验证成功
            this.$emit('promoCodeBlur',this.promoCode)
          } else{
            this.$emit('promoCodeBlur','')
            // this.$message.error(res.rspResult.message)
          }
        } catch (err) {
          console.error(
            '❌ ~ file: order-submission.vue:124 ~ submit ~ err:',
            err
          )
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.package-information {
  box-sizing: border-box;
  width: 1040px;
  background: #ffffff;
  padding: 20px 24px;
  > .ul {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    justify-content: space-between;
    h5 {
      margin-bottom: 0;
    }
    .li {
      display: flex;
      align-items: center;
      .label {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #4f5d78;
      }
      .value {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #16181a;
        margin-left: 8px;
      }
    }
  }
  h5 {
    margin-bottom: 20px;
    font-family: SourceHanSansCN-Bold;
    font-weight: 700;
    font-size: 16px;
    color: #16181a;
    letter-spacing: 0;
  }
  > .money {
    margin-top: 21px;
    display: flex;
    // justify-content: flex-end;
    align-items: center;
    > .labels {
      margin-right: 8px;
      margin-left: auto;
      .label {
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 12px;
        color: #4f5d78;
        letter-spacing: 0;
        margin-bottom: 8px;
        height: 12px;
        line-height: 12px;
        &:last-child {
          height: 22px;
          line-height: 22px;
        }
      }
    }
    > .values {
      .value {
        color: #4f5d78ff;
        font-size: 14px;
        min-width: 93px;
        text-align: right;
        margin-bottom: 8px;
        height: 12px;
        line-height: 12px;
        &:last-child {
          color: #ef2a2a;
          font-weight: bold;
          font-size: 20px;
          height: 22px;
          line-height: 22px;
          b {
            font-size: 16px;
          }
        }
      }
    }
  }
  ::v-deep .el-table th.el-table__cell {
    background: #f5f7fa !important;
  }
  ::v-deep .el-table__row {
    &:hover {
      .el-table_1_column_7 {
        background-color: #fff;
      }
      td:last-of-type {
        background-color: #fff !important;
      }
    }
    td:last-of-type {
      &:hover {
        background-color: #fff !important;
      }
    }
  }
  ::v-deep .el-table_1_column_7 {
    &:hover {
      background-color: #fff;
    }
  }
  ::v-deep tbody {
    .el-table__row:last-of-type,
    .el-table__row:nth-of-type(2) {
      td:last-of-type {
        display: none;
      }
    }
  }
}
</style>
